require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2005-11-20-sms.json") })
        }
      }, "path---articles-2005-11-20-sms");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2005-11-20-sms!./.cache/json/articles-2005-11-20-sms.json
// module id = 440
// module chunks = 231608221292675